import { fail } from "../infra/validation";
import { FEED_LIST_VOCABULARIES } from "@observe-tech/utils";

export { FEED_LIST_VOCABULARIES } from "@observe-tech/utils";

export type FeedList = keyof typeof FEED_LIST_VOCABULARIES;

export const assertValidFeedList = (list: FeedList, values: string[]): void => {
  const allowed: readonly string[] = FEED_LIST_VOCABULARIES[list];
  for (const value of values)
    if (!allowed.includes(value))
      fail(`${value} is not in the ${list} vocabulary`);
};
